import axios from '../utils/axios';

const baseUrl = `/api/admin`;

export const syncUserFromLdap = async () => {
  const requestUrl = `${baseUrl}/users/ldap/sync`;
  return await axios.post(requestUrl);
};
